/* eslint-disable no-mixed-spaces-and-tabs */
import Vue from 'vue'

// 变星号 前3位 和后两位
Vue.filter('changeStar', function(msg) {
    var str = msg.substring(0,3) + '***' +msg.substring(msg.length-2)
    return str
})

// 一位加0 两位不加
Vue.filter('memdayStart', function(msg) {
    return msg>9?msg:'0'+msg
})

// 截取字符串后两位 并去掉0开头
Vue.filter('splitLastTwo', function(msg) {
  if (!msg) {
    return
  }
  return Number(msg.substring(msg.length-2))
})

// 过滤两位小数
Vue.filter('retainTwo', function(value) {
   if (value==null) {
		return "--"
	}
	if (!value) {
		return '0'
	}else{
		return value.toFixed(2)
	}
})

// 日期变星期
Vue.filter('changeWeek', function(value) {
   	if (value=="--") {
        return value
    }else{
        var arys1 = new Array();
        arys1 = value.split('-');     //日期为输入日期，格式为 2013-3-10
        var ssdate = new Date(arys1[0], parseInt(arys1[1] - 1), arys1[2]);
        var week1=String(ssdate.getDay()).replace("0","日").replace("1","一").replace("2","二").replace("3","三").replace("4","四").replace("5","五").replace("6","六")
        return "星期"+week1
      }
})

// 时间戳变 - -
Vue.filter('changeTimeStamp', function(value) {
    if (!value) {
      return ''
    }else{
      var timeTemp=new Date(value)
      return timeTemp.getFullYear()+'-'+(timeTemp.getMonth()+1)+'-'+timeTemp.getDate()
    }
})
// 添加标题
Vue.directive("title",{
  inserted:function(el){
    console.log(el)
    document.title = el.dataset.title
  }
})